// @ts-check
export default {
    'common.operation': '操作',
    'common.add': '新增',
    'common.increase': '添加',
    'common.edit': '编辑',
    'common.modify': '修改',
    'common.query': '查询',
    'common.detail': '查看',
    'common.reset': '重置',
    'common.delete': '删除',
    'common.recover': '恢复',
    'common.deleteConfirm': '确定删除吗？',
    'common.recoverConfirm': '确定恢复吗？',
    'common.selectPlaceholder': '请选择',
    'common.inputPlaceholder': '请输入',
    'common.sure': '确定',
    'common.cancel': '取消',
    'common.saveAndNext': '保存并下一步',
    'common.prev': '上一步',
    'common.save': '保存',
    'common.recovery': '恢复',
    'common.submit': '提交',
    'common.excel': '导出',
    'common.agree': '同意',
    'common.reject': '拒绝',
    'common.placeHolder.beginTime': '请选择开始时间',
    'common.placeHolder.endTime': '请选择结束时间',
    'common.require.beginTime': '开始时间不为空',
    'common.require.endTime': '结束时间不为空',
    'common.validate.beginTime': '开始时间需小于结束时间',
    'common.validate.endTime': '结束时间需大于开始时间',
    'common.publish': '发布',
    'common.upload': '上传',
    'common.upload.image': '上传图片',
    'common.upload.video': '上传视频',
    'common.batchDelete': '批量删除',
    'common.select': '选择',
    'common.selectVerify': '至少选择一条!',
    'common.tip': '提示',
    'common.sync': '同步',
    'common.currency': '币种',
    'common.currency.placeholder': '请选择币种',
    'common.y': '是',
    'common.n': '否',
    'common.setting': '设置',
    'common.prompted': '系统提示',
    'common.reRequest': '请求超时，正在重新请求...',
    'common.tryAgain': '请求超时，请稍后再试',
    'common.select.user': '选择用户',
    'common.select.department': '部门',
    'common.user.userAndRealName': '用户账号/姓名',
    'common.user.account': '请输入账号',
    'common.user.username': '用户账号',
    'common.user.realname': '用户姓名',
    'common.user.sex': '性别',
    'common.user.phone': '手机',
    'common.user.department': '部门',
    'common.user.serach': '请输入关键字搜索',

    'common.upload.format': '请上传指定格式的文件',
    'common.upload.filename': '文件名过长，请修改文件名后重新上传',
    'common.upload.filesize': '文件大小不能超过',
    'common.upload.filenumber': '最多上传{number}个文件',
    'common.upload.fileimage': '张图片',
    'common.upload.filevideo': '个视频',
    'common.upload.imagelimit': '图片上传超过',
    'common.upload.imagesuffix': '张，请修改',
    'common.upload.videolimit': '视频上传超过',
    'common.upload.videosuffix': '个，请修改',
    'common.validate.noEmoji': '不能包含表情符号',
    'common.office.formatDesc': '文件格式不支持',
    'common.office.loading': '加 载 中...',
    'common.office.offlineDesc': '网络不可用，恢复后将自动加载',
    'common.column.min': '至少保留一个列',
    'common.formSetting.min': '至少保留一个筛选项'
  }
  